import { render, staticRenderFns } from "./Categories_Learner.vue?vue&type=template&id=35f9bd20&"
import script from "./Categories_Learner.vue?vue&type=script&lang=js&"
export * from "./Categories_Learner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports